import * as React from 'react';
import PanZoom from '@gomezhyuuga/react-pan-zoom';

import ModelPrintView from './components/ModelPrintView';
import Modal from 'src/components/common/Modal';
import DiagramModel from 'src/model/diagram.model';

import defaultImg from 'src/assets/defaultImage';
import './ModelDiagram.scss';

interface IModelDiagramProps {
  modelDiagram: DiagramModel;
  onPrint?: () => void;
  onPrintAll?: DiagramModel[];
  onDiagramOpened(diagramStatus: boolean): void;
  t?: any;
}

export interface IModelDiagramState {
  inverted: boolean;
  zoom: number;
  panX: number;
  panY: number;
  showActionsMenu: boolean;
  showModal: boolean;
  showPrintWindow: boolean;
  diagramsToPrint: DiagramModel[];
}

const ZOOM_STEP = 0.5;
const MIN_ZOOM = 1;

export default class ModelDiagram extends React.PureComponent<
  IModelDiagramProps,
  IModelDiagramState
> {
  public state = {
    inverted: false,
    zoom: MIN_ZOOM,
    panX: 0,
    panY: 0,
    showActionsMenu: false,
    showModal: false,
    showPrintWindow: false,
    diagramsToPrint: [] as DiagramModel[]
  };

  private panContainer: any;

  constructor(props: any) {
    super(props);
  }

  public render() {
    const diagramUrl = this.props.modelDiagram.urlDiagram;

    const inverted = this.state.inverted ? 'inverted' : '';
    const {
      panX,
      panY,
      zoom,
      showActionsMenu,
      showModal,
      showPrintWindow,
      diagramsToPrint
    } = this.state;

    const arrow = showActionsMenu ? 'up' : 'down';
    const { t } = this.props;

    return (
      <div id="rp-model-view--diagram">
        {showModal && (
          <Modal handleCloseModal={this.closeModal} showClose={true}>
            <img
              src={diagramUrl}
              alt="Model diagram"
              onError={this.onImgError}
            />
          </Modal>
        )}

        <div className={`diagram-box ${inverted}`}>
          <div className="diagram--controls">
            <div className="diagram--controls-left">
              <button onClick={this.zoomIn} id="diagram--controls--zoom-in">
                <i className="rpds-zoom-in" />
              </button>
              <button onClick={this.zoomOut} id="diagram--controls--zoom-out">
                <i className="rpds-zoom-out" />
              </button>
              <button onClick={this.reset} id="reset-state">
                <i className="rpds-zoom-out-map" />
              </button>
              <button onClick={this.invertDiagram}>
                <i className="rpds-iso" />
              </button>
            </div>

            <div className="diagram--controls-right">
              <button
                className="print"
                id="toggle-actions"
                onClick={this.toggleMenu}
              >
                <i className="rpds-print" />
                <span>{(t('common.print') as string).toUpperCase()}</span>
                <i className={`rpds rpds-arrow-drop-${arrow}`} />
              </button>
              {showActionsMenu && (
                <div className="subactions">
                  <button onClick={this.printDiagram}>
                    <i className="rpds-description" />
                    <span>{t('modelsPage.thisDiagram')}</span>
                  </button>
                  <button onClick={this.printAllDiagrams}>
                    <i className="rpds-file-copy" />
                    <span>{t('modelsPage.allDiagrams')}</span>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="diagram--container">
            <PanZoom
              onClick={this.showModal}
              onPan={this.onPan}
              pandx={panX}
              pandy={panY}
              zoom={zoom}
              ref={ref => (this.panContainer = ref)}
            >
              <img
                width="100%"
                src={diagramUrl}
                alt="Model diagram"
                className={inverted}
                onError={this.onImgError}
              />
            </PanZoom>
          </div>
        </div>
        {showPrintWindow && (
          <ModelPrintView
            diagrams={diagramsToPrint}
            closeWindow={this.closePrintWindow}
          />
        )}
      </div>
    );
  }

  /* 
    onImgError
   */
  private onImgError = (event: any) => {
    event.target.onerror = null;
    event.target.src = defaultImg;
  };

  private printDiagram = () => {
    if (this.props.onPrint) {
      this.props.onPrint();
    }

    this.setState({
      showActionsMenu: false,
      showPrintWindow: true,
      diagramsToPrint: [this.props.modelDiagram]
    });
  };
  private printAllDiagrams = () => {
    this.setState({
      showActionsMenu: false,
      showPrintWindow: true,
      diagramsToPrint: this.props.onPrintAll
    });
  };
  private closePrintWindow = () => {
    this.setState({ showPrintWindow: false });
  };
  private showModal = () => {
    this.props.onDiagramOpened(true);
    this.setState({ showModal: true });
  };
  private closeModal = () => {
    this.props.onDiagramOpened(false);
    this.setState({ showModal: false });
  };
  private toggleMenu = () => {
    this.setState(({ showActionsMenu }) => ({
      showActionsMenu: !showActionsMenu
    }));
  };
  private invertDiagram = () => {
    this.setState(({ inverted }) => ({
      inverted: !inverted
    }));
  };
  private zoomIn = () => {
    this.setState(({ zoom }) => ({
      zoom: zoom + ZOOM_STEP
    }));
  };
  private zoomOut = () => {
    this.setState(({ zoom }) => ({
      zoom: Math.max(MIN_ZOOM, zoom - ZOOM_STEP)
    }));
  };
  private onPan = (x: number, y: number) => {
    this.setState({ panX: x, panY: y });
  };
  private reset = () => {
    this.setState(
      {
        panX: 0,
        panY: 0,
        zoom: 1,
        inverted: false
      },
      () => {
        this.props.onDiagramOpened(true);
        this.setState({ showModal: true });
      }
    );
  };
}
